/**
 * Cart Single Product 
 */
let subscribeModeDoubleSS = $('#subscribeModeDoubleSS'),
    cartCTA = $('#cartCTA');

//- toggle checkboxes + CTA state
function cartSingleCheckboxToggle(e) {
    e.preventDefault();

    let checkboxInput = $(this).find('input');

    $(this).toggleClass('checked');

    checkboxInput.attr('data-checkbox', checkboxInput.attr('data-checkbox') == 'false' ? 'true' : 'false');

    if ($(this).parent('#subscribeMode').length) {
        if ($('#subscribeModeDoubleSS').length && !cartCTA.hasClass('disabled')) {
            cartCTA.addClass('disabled');
            
        } else {
            cartCTA.removeClass('disabled');
        }
    }

    if ($(this).parent('#subscribeModeDoubleSS').length) {
        if (cartCTA.hasClass('disabled')) {
            cartCTA.removeClass('disabled');

        } else {
            cartCTA.addClass('disabled');
        }
    }

    $('.cart--single .cart__product.active').trigger("click");
}

//- Toggle Disclaimer Checkbox, disable 2nd checkbox if length and Button disabled
function cartSingleDisclaimerToggle() {
    if ($('#disclaimerBox').hasClass('open')) {
        cartCTA.removeClass('disabled');
    }

    $('#disclaimerBox').toggleClass('open');

    if ($(subscribeModeDoubleSS).length && $(subscribeModeDoubleSS).find('input').attr('data-checkbox') == 'true') {
        $(subscribeModeDoubleSS).find('.subscribe-box__checked').removeClass('checked');

        $(subscribeModeDoubleSS).find('input').attr('data-checkbox', 'false');
    }
}

//- Set links
function cartSingleSetLinks() {
    let thisProduct = $(this),
        link,
        subscribeAttr = $('.cart--single #subscribeMode .subscribe-box__checkbox').attr('data-checkbox');

    if (subscribeAttr == 'true') {
        link = 'data-subscribe-link';
    } else {
        link = 'data-link';
    }

    let param = $('.cart--single .cta').attr('data-param');
    $('.cart--single .cta').attr('href', thisProduct.attr(link) + param);

    // Regular modal popup
    let modalCtaRegular = $('#regularButton'),
        modalCtaSubscribe = $('#subscribeButton'),
        linkRegular = 'data-link',
        linkSubscribe = 'data-subscribe-link';

    //- handle Regular Modal button links
    modalCtaRegular.attr('href', thisProduct.attr(linkRegular) + param);
    modalCtaSubscribe.attr('href', thisProduct.attr(linkSubscribe) + param);
}

// Calculate Instant and Member Savings based on retailVal and price
function cartSingleCalcSavings(subscribeAttr, thisProduct, retailVal) {
    let price = thisProduct.attr('data-price'),
        priceSubs = thisProduct.attr('data-subscribe-price');

    //- Calculate Savings and Member Savings based on data-retail, data-price and data-subscribe-price values
    let saving = Number(retailVal - price).toFixed(2),
        savingSubs = Number(retailVal - priceSubs).toFixed(2),
        memberSaving = Number(savingSubs - saving).toFixed(2);

    if (subscribeAttr == 'true') {
        $('.cart--single .saving__value').html('$' + savingSubs);
        $('.cart--single .member__value').html('$' + memberSaving);

    } else {
        $('.cart--single .saving__value').html('$' + saving);
    }
}

// Set Active Product
function activeProductSingle() {
    let thisProduct = $(this),
        amount = thisProduct.attr('data-units');

    let subscribeAttr = $('.cart--single .subscribe-box__checkbox').attr('data-checkbox');

    //- handle Modal popup
    let priceModalRegular = $('#purchaseModal').find('.amount--regular'),
        priceModalContinuity = $('#purchaseModal').find('.amount--continuity'),
        priceSubscribe = 'data-subscribe-price';

    const retail = thisProduct.attr('data-retail');

    cartSingleCalcSavings(subscribeAttr, thisProduct, retail);

    let price, shipping;

    $('#orderNow').removeClass(function (index, className) {
        return (className.match(/(^|\s)cart--unit\S+/g) || []).join(' ');
    }).addClass('cart--unit' + amount);

    if (subscribeAttr == 'true') {
        price = 'data-subscribe-price';
        shipping = 'data-subscribe-shipping';

        $('.cart--single .summary').addClass('summary--subscribe');

    } else {
        price = 'data-price';
        shipping = 'data-shipping';

        $('.cart--single .summary').removeClass('summary--subscribe');
    }

    let pricePerUnit = parseFloat(thisProduct.attr(price) / amount).toFixed(2);

    $('.cart--single .cart__product').removeClass('active');
    thisProduct.addClass('active');

    $('.cart--single .price-per-unit__value').html('$' + pricePerUnit);
    $('.cart--single .price__value').html('$' + thisProduct.attr(price));
    $('.cart--single .retail__value').html('$' + retail);
    $('.cart--single .shipping__value').html(thisProduct.attr(shipping));

    priceModalRegular.find('.amount__value').html('$' + thisProduct.attr(price));
    priceModalContinuity.find('.amount__value').html('$' + thisProduct.attr(priceSubscribe));

    if ($('.purchase-badges').length) {
        purchaseBadges($('.cart__body'), thisProduct, retail, thisProduct.attr(price));
    }
};

$('.cart--single .cart__product').on('click', cartSingleSetLinks);
$('.cart--single .cart__product').on('click', activeProductSingle);
$('.cart--single .subscribe-box__checked').on('click', cartSingleCheckboxToggle);
$('.cart--single #subscribeMode .subscribe-box__checked').on('click', cartSingleDisclaimerToggle);
$('.cart--single .cart__product.active').trigger("click");
